import { equal, greaterThan, length, notEqual } from "./javascript";
import {
  emailValidation,
  formatFieldName,
  isPastDate,
  isValidDate,
  passwordValidation,
  regularString,
  stringSpace,
  validateSocialMediaLink,
} from "./regex";

const formValidation = (
  name,
  value,
  state,
  ignore = [],
  optional = [],
  errorName
) => {
  const formErrors = { ...state.formErrors };
  if (ignore.includes(name)) {
    if (formErrors[name]) formErrors[name] = "";
    return formErrors;
  }

  switch (name) {
    case "name":
    case "fullName":
    case "category":
    case "distributor":
    case "publisher":
    case "agreementName":
    case "agreement":
    case "fullLegalName":
    case "artworkCreatorName":
    case "sideArtistFullLegalName":
    case "sideArtistName":
    case "producerName":
    case "director":
    case "coWriterFullLegalName":
    case "coWriterName":
    case "coWriterName2":
    case "coWriterFullLegalName2":
    case "accountingType":
    case "remixerFullLegalName":
    case "remixerName":
    case "artistPublisherName":
    case "artistIdentificationNumber":
    case "artistPublisherAddress":
    case "artistShare":
    case "coWriterFullLegalName":
      if (
        (equal(length(value)) || value == undefined) &&
        !optional.includes(name)
      ) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (!stringSpace(value)) {
        formErrors[name] = `Unnecessary space or special chracter in word!`;
      } else if (greaterThan(length(value), 35)) {
        formErrors[name] = `${formatFieldName(
          name
        )} exceeds character limit. Maximum allowed: 35 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "trackName":
    case "approvalProcess":
    case "deliveryMethod":
    case "credit":
    case "fee":
    case "accountingCost":
    case "accountingDispute":
    case "masterRoyalty":
    case "publishingRoyalty":
    case "address":
    case "artworkCreatorAddress":
    case "musicRelaseName":
    case "artWorkDescription":
    case "paymentStructure":
    case "deliveryFormat":
    case "revisonRound":
    case "producerAddress":
    case "sideArtistAddress":
    case "sideArtistFee":
    case "feeType":
    case "amount":
    case "days":
    case "bussinessAddress":
    case "realeaseTitle":
    case "scopeProduction":
    case "musicVideoFee":
    case "paymentSchedule":
    case "paymentTerms":
    case "videoFormat":
    case "disputeSettlement":
    case "approvalTime":
    case "coWriterAddress":
    case "coWriterAddress2":
    case "publishingSplit":
    case "controlledComposition":
    case "remixerAddress":
    case "remixFee":
    case "releaseName":
    case "editNumber":
    case "bearingTheCost":
    case "remixAudioFormat":
    case "splitPercentage":
    case "remixCredit":
    case "services":
    case "workflow":
    case "law":
    case "projectName":
    case "royalty":
    case "royaltyPaymentTimeline":
    case "royaltyThreshold":
    case "noticePeriod":
    case "labelWavier":
    case "indemnification":
    case "warrenties":
    case "notice":
      if (equal(length(value)) && !optional.includes(name)) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (!/^[a-zA-Z0-9\s-,_,.]+$/.test(value)) {
        // Allow alphanumeric and spaces
        formErrors[name] = `Please enter a valid ${formatFieldName(
          name
        )} (only letters, numbers, and spaces are allowed).`;
      } else if (greaterThan(length(value), 70)) {
        formErrors[name] = `${formatFieldName(
          name
        )} exceeds character limit. Maximum allowed: 70 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "deadline":
    case "deliveryDate":
      if (!value) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else {
        const parsedDate = new Date(value);

        // Check if the entered value is a valid date
        if (isNaN(parsedDate.getTime())) {
          formErrors[name] = `${formatFieldName(name)} must be a valid date!`;
        } else {
          formErrors[name] = "";
        }
      }
      break;

    case "email":
    case "email1":
    case "email2":
      if (equal(length(value)) && !optional.includes(name)) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (value && !emailValidation(value)) {
        formErrors[name] = `Please enter valid email!`;
      } else {
        formErrors[name] = "";
      }
      break;
    case "aboutMe":
    case "about":
      if (equal(length(value)) || value == undefined) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (greaterThan(length(value), 500)) {
        formErrors[name] = `${formatFieldName(
          name
        )} exceeds character limit. Maximum allowed: 500 characters.`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "link":
      const socialMediaTypes = [
        "Spotify",
        "Facebook",
        "x",
        "Instagram",
        "Tiktok",
        "appleMusic",
        "Youtube",
        "Soundcloud",
      ];
      if (value?.type && socialMediaTypes.includes(value?.type)) {
        if (equal(length(value?.value))) {
          formErrors[name] = `${formatFieldName(
            value?.type
          )} link is required!`;
        } else if (!validateSocialMediaLink(value?.value, value?.type)) {
          formErrors[name] = `Please enter a valid ${formatFieldName(
            value?.type
          )} link`;
        } else {
          formErrors[name] = "";
        }
      } else {
        if (equal(length(value?.value)) || equal(length(value))) {
          formErrors[name] = `${formatFieldName(name)} is required!`;
        } else {
          formErrors[name] = "";
        }
      }
      break;

    case "type":
      if (equal(length(value)) || value == undefined) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "password":
      if (equal(length(value))) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (!passwordValidation(value)) {
        formErrors[
          name
        ] = `Please enter a password with 8-16 characters, 1 uppercase letter, 1 lowercase letter, 1 number, and 1 special character`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "artworkFee":
    case "additionalCharges":
      if (equal(length(value))) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else {
        formErrors[name] = "";
      }
      break;

    case "confirmPassword":
      if (equal(length(value))) {
        formErrors[name] = `${formatFieldName(name)} is required!`;
      } else if (notEqual(state.password, value)) {
        formErrors[name] = `Password and Confirm Password is not match!`;
      } else if (equal(state.password, value)) {
        formErrors[name] = "";
      }
      break;
    default:
      break;
  }
  return formErrors;
};
export default formValidation;
